



















































































































































































import { Vue, Component, Prop } from "vue-property-decorator";
import { EnrollmentOrderShort as IEnrollmentOrder } from "@/api/models/enrollment-order-short";
import { Course as ICourse } from "@/api/models/course";
import { Course as ICourseV2 } from "@/api-v2/course/models/course";
import api from "@/getinfo-api";
import { AxiosError } from "axios";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models";
import DeleteMaterialModal from "@/components/form/DeleteMaterialModal.vue";

@Component({
  components: { DeleteMaterialModal }
})
export default class enrollmentOrderItem extends Vue {
  @Prop() enrollmentOrder!: IEnrollmentOrder;
  course!: ICourse | ICourseV2;
  showDeleteModal: boolean = false;

  data() {
    return {
      course: undefined
    };
  }

  get linkToCourse() {
    const v1 = {
      name: "courseView",
      params: { courseId: this.enrollmentOrder?.course?.id }
    };
    const v2 = {
      name: "course",
      params: { id: this.enrollmentOrder?.course?.id }
    };

    return this.enrollmentOrder?.course?.version === "v2" ? v2 : v1;
  }

  deleteEnrollment() {
    api.EnrollmentOrderApi._delete(this.enrollmentOrder.id)
      .then(() => {
        this.showDeleteModal = false;
        this.$emit("deleteEnrollmentOrder");
      })

      .catch((error: AxiosError<IValidationErrorResponse>) => {
        if (error.response) {
          this.$bvToast.toast(`${error.response.data.message}`, {
            variant: "danger",
            title: `${this.$tc(this.$translate.Error)}`
          });
        } else {
          this.$bvToast.toast(`${this.$tc(this.$translate.Error)}`, {
            variant: "danger",
            title: `${this.$tc(this.$translate.Error)}`
          });
        }
      });
  }

  showDeleteForm() {
    this.showDeleteModal = true;
  }

  hideDeleteModal() {
    this.showDeleteModal = false;
  }

  get screenWidth() {
    return window.innerWidth;
  }
}
